/** @flow */
import Helmet from 'react-helmet';
import QueryString from 'query-string';
import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import LoadingSpinner from 'common/components/LoadingSpinner';
import { RegistrationWrapper, RegistrationCard, RegistrationSection, ButtonSubmit, Logo } from 'common/modules/registration/styles';

import { closeSession } from '../../authentication/session/actions/sessionActions';

import { hasConfirmEmailError, isUpdating } from '../selector/userProfileSelector';
import { confirmEmail } from '../actions/userProfileActions';
import { Metrics, Fonts } from '../../../themes';

const styles = {
  header: {
    ...Fonts.style.sub,
    fontWeight: 'bold',
    textAlign: 'center',
  },
};

const ErrorMessage = styled.div`
  margin-bottom: ${Metrics.largeMargin}px;
`;

const SuccessMessage = styled.span`
  margin-bottom: ${Metrics.largeMargin}px
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  margin: ${Metrics.margin}px 0;
`;

type Props = {
  isAuthenticated: boolean;
  confirmError: boolean;
  updating: boolean;
  t: any;
  theme: any;
  actions: {
    closeSession: () => mixed;
    confirmEmail: (token: string) => Promise<*>,
    openSnackbar: (type: string, message: string) => mixed,
  }
};

type State = {
  token: string;
  redirect: boolean;
}

class ConfirmEmailPage extends Component<Props, State> {
  state: State;

  constructor(props) {
    super(props);

    this.state = {
      token: '',
      redirect: false,
    };
  }

  componentWillMount() {
    if (this.props.isAuthenticated) {
      this.props.actions.closeSession();
    }

    const queryParams = QueryString.parse(location.search);
    if (!queryParams || !queryParams.token) {
      this.setState({ redirect: true });
    } else {
      this.props.actions.confirmEmail(queryParams.token);
    }

    if (!this.props.confirmError) {
      this.props.actions.openSnackbar('message', this.props.t('confirmEmailSuccess'));
    }
  }

  setRedirect = () => {
    this.setState({
      redirect: true,
    });
  }

  render() {
    const {
      confirmError, updating, t, theme: { images: { logo, background } },
    } = this.props;

    return (
      <RegistrationWrapper background={background}>
        { this.state.redirect &&
          <Redirect to="/" />
        }
        <Helmet>
          <title>{t('confirmEmail')}</title>
        </Helmet>
        <RegistrationCard zDepth={5}>
          <RegistrationSection>
            <Logo src={logo} alt="logo" />
            <h2 style={styles.header}>{t('confirmEmail')}</h2>
            { updating &&
              <LoadingSpinner size="medium" />
            }
            { confirmError &&
              <ContentWrapper>
                <ErrorMessage style={{ ...Fonts.style.midSmall, lineHeight: 1.5 }}>
                  {t('confirmEmailError')}
                </ErrorMessage>
                <ButtonSubmit onClick={() => this.setRedirect()}>{t('goToHome')}</ButtonSubmit>
              </ContentWrapper>
            }
            { !updating && !confirmError &&
              <ContentWrapper>
                <SuccessMessage>{t('confirmEmailSuccess')}</SuccessMessage>
                <ButtonSubmit onClick={() => this.setRedirect()}>
                  {t('goToHome')}<i className="material-icons" style={{ verticalAlign: 'middle' }}>chevron_right</i>
                </ButtonSubmit>
              </ContentWrapper>
            }
          </RegistrationSection>
        </RegistrationCard>
      </RegistrationWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    confirmError: hasConfirmEmailError(state),
    updating: isUpdating(state),
    isAuthenticated: state.session.isAuthenticated,
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ confirmEmail, closeSession, openSnackbar }, dispatch),
  };
}

export default translate('userProfile')(connect(mapStateToProps, mapDispatchToProps)(withTheme((ConfirmEmailPage))));



// WEBPACK FOOTER //
// ./src/statsradio/modules/userProfile/components/ConfirmEmailPage.js